export const MODAL_TYPES = {
  SAVE: "save",
  EDIT: "edit",
  ADD_TO_DASHBOARD: "add-to-dashboard",
  MOVE: "move",
  CLONE: "clone",
  ARCHIVE: "archive",
  SAVED: "saved",
  ADD_TO_DASHBOARD_SAVE: "add-to-dashboard-save",
  CREATE_ALERT: "create-alert",
  SAVE_QUESTION_BEFORE_ALERT: "save-question-before-alert",
  SAVE_QUESTION_BEFORE_EMBED: "save-question-before-embed",
  HISTORY: "history",
  EMBED: "embed",
  TURN_INTO_DATASET: "turn-into-dataset",
  CAN_NOT_CREATE_MODEL: "can-not-create-model",
};
